import React, { useContext, useState } from 'react';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import { PayAsYouGoOrderAPI, DiscountCodeValidationAPI } from './api-services/order.service';
import { localStorageKeys } from '../global/constants';
import axios from 'axios';
import { OnTheMenuDataContext } from './OnTheMenuDataProvider';
import { LoginDataContext } from './LoginDataProvider';
import { GlobalStateDataContext } from './GlobalStateDataProvider';
import { isMobile } from '../global/ScreenSizeHelper';
import { Step, StepLabel, Stepper } from '@mui/material';
import Loader from '../composed/Loader/Loader';
import AtomicButton from '../atomic/button/AtomicButton';
import { canPlaceOrder } from '../global/generateDeliveryTimeSlots';

export const CheckoutDataContext = React.createContext();

const CheckoutDataProvider = ({ children }) => {
  const navigate = useNavigate();
  const {
    payAsYouGoPayloadForCheckout,
    promotionalOrderPayloadForCheckout,
    cartItems,
    Qty,
    sortedKitchenData,
    subtotalInCart,
  } = useContext(OnTheMenuDataContext);

  const { customerInfoData } = useContext(LoginDataContext);
  const { onLoadInfoResponse } = useContext(GlobalStateDataContext);

  const [tip, setTip] = useState(0);
  const [tipType, setTipType] = useState('amount');
  const { TOKEN, URL_INFLUE_CODE } = localStorageKeys;
  const [payAsYouGoOrderData, setPayAsYouGoOrderData] = useState({
    loading: false,
    data: null,
    errorMessage: '',
    success: null,
  });

  const [mealOrderData, setMealOrderData] = useState({
    loading: false,
    data: null,
    errorMessage: '',
    success: null,
  });

  const [discountCodeValidationData, setDiscountCodeValidationData] = useState({
    loading: false,
    data: null,
    errorMessage: '',
    success: null,
  });
  const [orderConfirmationData, setOrderConfirmationData] = useState({
    MealOrderResponse: null,
    PayAsYouGoOrderResponse: null,
    PromotionalOrderResponse: null,
    DiscountCodeValidationResponse: null,
  });

  const [promoCodeOrderSummary, setPromoCodeOrderSummary] = useState({});

  const [errorOnPayAsYouGoOrder, setErrorOnPayAsYouGoOrder] = useState(false);
  const [errorOnMealOrder, setErrorOnMealOrder] = useState(null);
  const [openPlaceOrderLoader, setOpenPlaceOrderLoader] = useState(false);
  const [displayText, setdisplayText] = useState('...Placing order');
  const [placeOrderLoaderContent, setPlaceOrderLoaderContent] = useState('');
  const { data } = customerInfoData;
  const { operation_start_time, operation_end_time, pickup_order_promotion } = sortedKitchenData;
  const BranchFlags = onLoadInfoResponse?.data?.data?.data?.operationFlags || {};
  const custReasonStatus = data?.data?.user_Info?.reason_status;
  const CheckLenghtPayAsYouGo = () =>
    payAsYouGoPayloadForCheckout &&
    (payAsYouGoPayloadForCheckout?.item_names?.length > 0 ||
      payAsYouGoPayloadForCheckout?.meal_item_names?.length > 0);

  const CheckLengthPromoItem = () =>
    promotionalOrderPayloadForCheckout && promotionalOrderPayloadForCheckout?.item_name?.length > 0;

  const getInflueLocalStorage = () => localStorage.getItem(URL_INFLUE_CODE);

  // All the keys are mentioned payload Example for payAsYouGoOrder API
  // const PayAsYouGoOrder_Payload_Sample= {
  //     email: "5115@testpostman.com",
  //     item_names: [
  //         {
  //             item: "veggi biryani",
  //             qty: 1,
  //             extra_toppings: [
  //                 {
  //                     topping_name: "Cheese",
  //                     topping_qty: 1
  //                 }
  //             ]
  //         },
  //         {
  //             item: "mutton biryani",
  //             qty: 1,
  //             extra_toppings: [
  //                 {
  //                     topping_name: "Cheese",
  //                     topping_qty: 1
  //                 }
  //             ]
  //         }
  //     ],
  //     delivery_date: "07/21/2024",
  //     delivery_time_slot: "02:00 PM - 03:00 PM",
  //     delivery_type: "home delivery",
  //     delivery_address: "6644 talman",
  //     kitchen_id: "65864020b4f4bc3c58ba0a95",
  //     kitchen_name: "9001postmankitchen",
  //     device: "desktop",
  //     tip: 2,
  //     discount_coupon_no: "",
  //     subscription_order_no: "",
  //     kitchenAgreedForFreeComboPromo: true,
  //     branchAgreedFreeComboPromoForPayAsYouGo: false,
  //     comboPromoOrderPlaced: true
  // }

  const onPayAsYouGoOrderApiHandler = async (payload) => {
    try {
      const gettingToken = localStorage.getItem(TOKEN);
      if (gettingToken) {
        axios.defaults.headers.common.Authorization = `Bearer ${gettingToken}`;
      } else {
        setPayAsYouGoOrderData({
          success: false,
          loading: false,
          data: null,
          errorMessage: 'Token & Refresh Token missing',
        });
        return;
      }

      await setPayAsYouGoOrderData({
        loading: true,
        success: null,
        data: null,
        errorMessage: '',
      });

      const orderdata = await PayAsYouGoOrderAPI(payload);
      if (orderdata.hasError) {
        await setPayAsYouGoOrderData({
          loading: false,
          data: null,
          success: !orderdata.hasError,
          errorMessage: orderdata.message,
        });
        return { payAsYouGoOrderData: orderdata };
      }

      if (orderdata?.data?.success) {
        await setPayAsYouGoOrderData({
          loading: false,
          data: orderdata,
          success: orderdata?.data?.success,
          errorMessage: null,
        });
        return { payAsYouGoOrderData: orderdata };
      } else {
        await setPayAsYouGoOrderData({
          loading: false,
          data: null,
          success: orderdata.data?.success,
          errorMessage: orderdata.data?.errors,
        });
      }
      return { payAsYouGoOrderData: orderdata };
    } catch (error) {
      console.log('-----Catch block onPayAsYouGoOrderApiHandler', error);
      setPayAsYouGoOrderData({ data: null, isLoading: false, errorMessage: error, success: false });
    }
  };

  const onDiscountCodeValidationApiHandler = async (payload) => {
    try {
      const gettingToken = localStorage.getItem(TOKEN);
      if (gettingToken) {
        axios.defaults.headers.common.Authorization = `Bearer ${gettingToken}`;
      } else {
        setDiscountCodeValidationData({
          success: false,
          loading: false,
          data: null,
          errorMessage: 'Token & Refresh Token missing',
        });
        return;
      }

      await setDiscountCodeValidationData({
        loading: true,
        success: null,
        data: null,
        errorMessage: '',
      });

      setPromoCodeOrderSummary({});

      const DiscountCodedata = await DiscountCodeValidationAPI(payload);
      if (DiscountCodedata.hasError) {
        await setDiscountCodeValidationData({
          loading: false,
          data: null,
          success: !DiscountCodedata.hasError,
          errorMessage: DiscountCodedata.message,
        });
        return { discountCodeData: DiscountCodedata };
      }

      if (DiscountCodedata?.data?.success) {
        await setDiscountCodeValidationData({
          loading: false,
          data: DiscountCodedata,
          success: DiscountCodedata.data?.success,
          errorMessage: null,
        });

        return { discountCodeData: DiscountCodedata };
      } else {
        await setDiscountCodeValidationData({
          loading: false,
          data: null,
          success: DiscountCodedata?.data?.success,
          errorMessage: DiscountCodedata?.data?.errors,
        });
      }
      return { discountCodeData: DiscountCodedata };
    } catch (error) {
      console.log('-----Catch block onDiscountCodeValidationApiHandler', error);
      setDiscountCodeValidationData({
        data: null,
        isLoading: false,
        errorMessage: error,
        success: false,
      });
    }
  };

  // Code for Checkout PLace order Btn

  const WhosPromoFlagApplied = () => {
    // We need to check kitchen flag first
    if (
      sortedKitchenData?.agreedForFreeComboPromo &&
      subtotalInCart >= sortedKitchenData?.amountRequiredForComboPromo &&
      CheckLengthPromoItem()
    ) {
      return {
        branchFlagApplied: false,
        kitchenFlagApplied: true,
        updateInOrder: 'payAsYouGoOrder',
        test: '1',
      };
    }

    if (BranchFlags?.branchAgreedFreeComboPromoForSubscription && CheckLengthPromoItem()) {
      const checkOne =
        BranchFlags?.branchAgreedFreeComboPromoForPayAsYouGo &&
        subtotalInCart >= BranchFlags?.amountRequiredForComboPromo;
      return {
        branchFlagApplied: true,
        kitchenFlagApplied: false,
        updateInOrder: checkOne
          ? 'payAsYouGoOrder'
          : cartItems?.mealItems?.length > 0
            ? 'mealOrder'
            : 'none',
        test: '2',
      };
    }
    if (
      BranchFlags?.branchAgreedFreeComboPromoForPayAsYouGo &&
      CheckLengthPromoItem() &&
      subtotalInCart >= BranchFlags?.amountRequiredForComboPromo
    ) {
      return {
        branchFlagApplied: true,
        kitchenFlagApplied: false,
        updateInOrder: 'payAsYouGoOrder',
        test: '3',
      };
    }
    return {
      branchFlagApplied: false,
      kitchenFlagApplied: false,
      updateInOrder: 'none',
      test: '4',
    };
  };

  const FlagApplied = () =>
    WhosPromoFlagApplied().branchFlagApplied
      ? 'regional branch'
      : WhosPromoFlagApplied().kitchenFlagApplied
        ? 'kitchen'
        : 'none';

  // MealItem QTY calculation
  const reducedMealItems = {};

  payAsYouGoPayloadForCheckout?.meal_item_names?.forEach((obj) => {
    const key = obj.item;

    if (!reducedMealItems[key]) {
      reducedMealItems[key] = {
        item: key,
        qty: 0,
        mealItemPrice: obj.mealItemPrice,
        product_category: obj.product_category,
      };
    }

    reducedMealItems[key].qty += 1;
  });

  const mealItems = [];

  Object.keys(reducedMealItems).map((key) => {
    mealItems.push({
      item: key,
      qty: reducedMealItems[key]?.qty, // new added .qty
      mealItemPrice: reducedMealItems[key]?.mealItemPrice, // new added
      product_category: reducedMealItems[key]?.product_category, // new added
      menu: reducedMealItems[key]?.menu, // new added
    });
  });

  const PromotionOrder_Payload = {
    item_names: promotionalOrderPayloadForCheckout?.item_name,
    delivery_date: promotionalOrderPayloadForCheckout?.delivery_date,
    delivery_time_slot: promotionalOrderPayloadForCheckout?.delivery_time_slot,
    delivery_type: promotionalOrderPayloadForCheckout?.delivery_type,
    delivery_address: promotionalOrderPayloadForCheckout?.delivery_address,
    customer_geolocation: promotionalOrderPayloadForCheckout?.customer_geolocation,
    kitchen_id: promotionalOrderPayloadForCheckout?.kitchen_id,
    kitchen_name: promotionalOrderPayloadForCheckout?.kitchen_name,
    kitchen_phone_no: promotionalOrderPayloadForCheckout?.kitchen_phone_no,
    kitchen_geolocation: promotionalOrderPayloadForCheckout?.kitchen_geolocation,
    whosComboPromoFlagApplied: FlagApplied(),
    nextday_meal_price: promotionalOrderPayloadForCheckout?.nextday_meal_price,
    nextday_meal_qty: Qty,
  };

  const PayAsYouGoOrder_Payload = {
    email: payAsYouGoPayloadForCheckout?.CustomerEmail,
    item_names: payAsYouGoPayloadForCheckout?.item_names,
    meal_item_names: mealItems,
    delivery_date: payAsYouGoPayloadForCheckout?.delivery_date,
    delivery_time_slot: payAsYouGoPayloadForCheckout?.delivery_time_slot,
    delivery_type: payAsYouGoPayloadForCheckout?.delivery_type,
    dedicated_drivers: payAsYouGoPayloadForCheckout?.dedicated_drivers || [],
    delivery_fee: payAsYouGoPayloadForCheckout?.delivery_price,
    delivery_address: payAsYouGoPayloadForCheckout?.delivery_address,
    delivery_fee_applied: payAsYouGoPayloadForCheckout?.delivery_fee_Applied,
    delivery_option_type: payAsYouGoPayloadForCheckout?.delivery_option_type,
    delivery_price_without_merch_agreement:
      payAsYouGoPayloadForCheckout?.delivery_price_without_merch_agreement,
    customer_geolocation: payAsYouGoPayloadForCheckout?.customer_geolocation,
    kitchen_id: payAsYouGoPayloadForCheckout?.kitchen_id,
    kitchen_name: payAsYouGoPayloadForCheckout?.kitchen_name,
    influencer_promoter_id: getInflueLocalStorage() || 'none',
    device: 'desktop',
    tip: +tip.toFixed(2),
    discount_coupon_no:
      promoCodeOrderSummary?.PromoCodeFor === 'PayAsYouGoOrder'
        ? promoCodeOrderSummary?.promoCode
        : null,
    subscription_order_no: '', // subscrition_order_no is added when PlaceOrderBtn() is clicked
    joined_order_no: '', // joined_order_no is added when PlaceOrderBtn() is clicked
    whosComboPromoFlagApplied: FlagApplied(), // kitchen || regional branch || none
    comboPromoOrderPlaced: CheckLengthPromoItem()
      ? true
      : WhosPromoFlagApplied().updateInOrder === 'payAsYouGoOrder'
        ? true
        : false,
    promotion_order_payload: CheckLengthPromoItem() ? PromotionOrder_Payload : null,

    upsale_item_names: payAsYouGoPayloadForCheckout?.upsale_item_names,
    upsale_amount: payAsYouGoPayloadForCheckout?.upsale_amount,
    oneTimeMeal_amount: payAsYouGoPayloadForCheckout?.oneTimeMeal_amount,
    oneTimeMeal_persons: payAsYouGoPayloadForCheckout?.oneTimeMeal_persons,
    pickup_free_item:
      payAsYouGoPayloadForCheckout?.pickup_free_item?.name !== 'none'
        ? payAsYouGoPayloadForCheckout?.pickup_free_item
        : null,

    standard_delivery_free_item:
      payAsYouGoPayloadForCheckout?.standard_delivery_free_item?.name !== 'none'
        ? payAsYouGoPayloadForCheckout?.standard_delivery_free_item
        : null,
  };

  const OrderPlacingLoader = (orderType) => {
    const steps = [];
    const stepperMapping = {
      // 'meal order': 'Meal order',
      'payasyougo order': 'Regular menu order',
      'promotion order': 'Promotion menu order',
      successful: 'Order placed',
    };

    if (CheckLenghtPayAsYouGo()) {
      steps.push('Regular menu order');
    }

    if (CheckLengthPromoItem()) {
      steps.push('Promotion menu order');
    }

    steps.push('Order placed');

    const stepperProps = isMobile ? { orientation: 'vertical' } : { alternativeLabel: true };
    const activeStep = steps.findIndex((step) => orderType && step === stepperMapping[orderType]);
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          height: '100px',
          width: 'auto',
          height: 'auto',
        }}
      >
        <Stepper activeStep={activeStep} {...stepperProps}>
          {steps.map((label) => (
            <Step key={label}>
              <StepLabel>{label}</StepLabel>
            </Step>
          ))}
        </Stepper>
        <div
          style={{
            margin: '20px 0px 20px 0px',
            fontFamily: 'Roboto Regular',
            fontSize: '18px',
            color: '#FF893A',
          }}
        >
          Thank you for choosing us
        </div>

        <AtomicButton
          label={<Loader width='20px' />}
          style={{
            fontSize: '16px',
            height: '50px',
          }}
          handleSubmit={() => console.log('---Btn clicked')}
          endIcon={''}
          startIcon={''}
        ></AtomicButton>
      </div>
    );
  };

  const onPlaceOrderHandler = async () => {
    // setOrderConfirmationData({})
    let clonedOrderConfirmationData = { ...orderConfirmationData };
    setErrorOnMealOrder(null);
    const sletedDateOne = payAsYouGoPayloadForCheckout?.delivery_date;
    const current = moment();
    const start = moment(
      new Date(
        `${moment(sletedDateOne, 'MM/DD/YYYY').format('ddd DD-MMM-YYYY')}, ${operation_start_time}`
      )
    );
    const isOpen =
      (sletedDateOne === current.format('MM/DD/YYYY') && current < start) ||
      canPlaceOrder(sletedDateOne, operation_start_time, operation_end_time);

    if (!isOpen) {
      setErrorOnMealOrder(`Store is closed for today, Open at ${operation_start_time} tomorrow 1`);
      return;
    }

    if (PayAsYouGoOrder_Payload?.standard_delivery_free_item !== null) {
      const StandardDeliveryPromotion =
        onLoadInfoResponse?.data?.data?.data?.operationFlags?.standard_delivery_promotion;

      const DisableBtnRegional = subtotalInCart >= StandardDeliveryPromotion?.minimumAmountSpend;
      if (!DisableBtnRegional) {
        setErrorOnMealOrder(
          `Remove standard delivery free item — minimum spend of $${StandardDeliveryPromotion?.minimumAmountSpend} required.`
        );
        return;
      }
    }
    if (PayAsYouGoOrder_Payload?.pickup_free_item !== null) {
      const DisableBtnPickupMerchant = subtotalInCart >= pickup_order_promotion?.minimumAmountSpend;

      if (!DisableBtnPickupMerchant) {
        setErrorOnMealOrder(
          `Remove pickup free item — minimum spend of $${pickup_order_promotion?.minimumAmountSpend} required.`
        );
        return;
      }
    }

    setErrorOnMealOrder(null);
    setOpenPlaceOrderLoader(true);
    setErrorOnPayAsYouGoOrder(false);
    setdisplayText('Placing order...');
    setPlaceOrderLoaderContent(OrderPlacingLoader());

    if (custReasonStatus === 'Card decline' || custReasonStatus === 'Card adding pending') {
      setErrorOnMealOrder('Card Declined');
      setOpenPlaceOrderLoader(false);
      return;
    }

    if (CheckLenghtPayAsYouGo()) {
      // setErrorOnPayAsYouGoOrder(true)
      let ApplyJoinedOrderNo = null;
      let MealOrderNoOne = null;

      const PayAsYouGoOrder = await onPayAsYouGoOrderApiHandler({
        ...PayAsYouGoOrder_Payload,
        joined_order_no: ApplyJoinedOrderNo,
        subscription_order_no: MealOrderNoOne,
      });
      const Respo = PayAsYouGoOrder?.payAsYouGoOrderData?.data;

      if (
        PayAsYouGoOrder?.payAsYouGoOrderData?.hasError === true &&
        PayAsYouGoOrder?.payAsYouGoOrderData?.message === 'Network Error'
      ) {
        setErrorOnPayAsYouGoOrder(true);
        setOpenPlaceOrderLoader(false);
        return;
      }

      if (PayAsYouGoOrder?.payAsYouGoOrderData?.hasError === true) {
        setErrorOnMealOrder('Something is wrong please contact helpdesk Ref:9944'); // we are using same state for meal order as dont want to create another state for payasyougo
        setErrorOnPayAsYouGoOrder(true);
        setOpenPlaceOrderLoader(false);
        return;
      }

      if (Respo?.success === false) {
        setErrorOnPayAsYouGoOrder(true);
        setOpenPlaceOrderLoader(false);
        return;
      }

      /* 


            Errors Handle when Meal order is placed and something got wrong on payasyougo order we need to check
            what time shot was sent with meal order then empty payasyougo order and tell user to start process again 
            as time slot is diffrenet on meal order both has to be same 

            - Time Slot Error in past  ( we have to empty  setMealOrderPayloadForCheckout({}) && setOrderConfirmationData({ ...orderConfirmationData, MealOrderResponse: null }))
           
            */

      // PayAsYouGoOrder is successful
      if (Respo?.success) {
        setPlaceOrderLoaderContent(OrderPlacingLoader('payasyougo order'));
        // setOrderConfirmationData({ ...orderConfirmationData, PayAsYouGoOrderResponse: PayAsYouGoOrder })
        clonedOrderConfirmationData = {
          ...clonedOrderConfirmationData,
          PayAsYouGoOrderResponse: PayAsYouGoOrder,
        };
        setOrderConfirmationData(clonedOrderConfirmationData);
      }
    }

    // Last Block , We have to close dailog and redirect to order confirmation page
    setPlaceOrderLoaderContent(OrderPlacingLoader('successful'));

    setTimeout(() => {
      setOpenPlaceOrderLoader(false);
      navigate(`/orderconfirmation`);
    }, 2000);
  };

  return (
    <CheckoutDataContext.Provider
      value={{
        PromotionOrder_Payload,
        onPayAsYouGoOrderApiHandler,
        payAsYouGoOrderData,
        setPayAsYouGoOrderData,
        mealOrderData,
        setMealOrderData,
        onDiscountCodeValidationApiHandler,
        discountCodeValidationData,
        setDiscountCodeValidationData,
        orderConfirmationData,
        setOrderConfirmationData,
        tip,
        setTip,
        tipType,
        setTipType,
        promoCodeOrderSummary,
        setPromoCodeOrderSummary,
        openPlaceOrderLoader,
        setOpenPlaceOrderLoader,
        placeOrderLoaderContent,
        setPlaceOrderLoaderContent,
        errorOnPayAsYouGoOrder,
        setErrorOnPayAsYouGoOrder,
        errorOnMealOrder,
        setErrorOnMealOrder,
        displayText,
        setdisplayText,
        onPlaceOrderHandler,
        // MealOrder_Payload,
        PayAsYouGoOrder_Payload,
        PromotionOrder_Payload,
      }}
    >
      {children}
    </CheckoutDataContext.Provider>
  );
};

export default CheckoutDataProvider;
